import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputClass = "w-full bg-transparent border-b border-[#0A1128]/25 py-3 text-[#0A1128] placeholder:text-[#0A1128]/40 focus:border-[var(--gold)] focus:outline-none transition-colors";

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAF9F6]">
      <div className="hidden lg:block relative overflow-hidden">
        <img src="https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjByZWFsJTIwZXN0YXRlJTIwZXh0ZXJpb3J8ZW58MHx8fHwxNzg1ODYwMzMyfDA&ixlib=rb-4.1.0&q=85"
          alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0A1128]/40" />
        <div className="absolute bottom-12 left-12 text-[#FAF9F6]">
          <p className="font-serif text-4xl">Agent Portal</p>
          <p className="text-[#FAF9F6]/70 mt-2">Manage your collection & inquiries.</p>
        </div>
      </div>
      <div className="grid place-items-center px-6">
        <div className="w-full max-w-sm">
          <Link to="/" className="text-xs uppercase tracking-[0.2em] text-[var(--gold)]">← Back to Site</Link>
          <h1 className="font-serif text-4xl text-[#0A1128] mt-6 mb-2">Sign In</h1>
          <p className="text-[var(--slate)] text-sm mb-10">Access your private dashboard.</p>
          <form onSubmit={submit} className="space-y-6" data-testid="login-form">
            <input data-testid="login-email" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputClass} />
            <input data-testid="login-password" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputClass} />
            <button data-testid="login-submit" disabled={loading}
              className="w-full py-4 bg-[#0A1128] text-[#FAF9F6] text-sm uppercase tracking-[0.14em] hover:bg-[#1a2342] transition-colors duration-300 disabled:opacity-60">
              {loading ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
